let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("dWaws"), load("kKuAo")]).then(() => parcelRequire('8igvv'));